import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import PositionProfitLossChart from "../Charts/PositionProfitLossChart";
import PositionResultTable from "./PositionResultTable";
import LongShortChart from "../Charts/LongShortChart";

const ResultsByPosition = ({ data }) => {
  console.log("ResultsByPosition", data);

  const labels = Object.keys(data).map(Number); // Convert keys to numbers for labels
  const seriesData = Object.values(data).map((item) =>
    Number(item.results).toFixed(2)
  );

  return (
    <>
      <LongShortChart labels={labels} seriesData={seriesData} />
    </>
  );
};

export default ResultsByPosition;
